import React from 'react'
import { Dialog,Slide, useTheme, useMediaQuery } from '@mui/material';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

function ConfirmDialog({open,handleClose,fullWidth,children,maxWidth,...props}){
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('md'));
    return <Dialog
    disableBackdropClick
    open={open}
    TransitionComponent={Transition}
   /*  keepMounted */
    fullWidth={fullWidth}
    maxWidth={maxWidth}
    fullScreen = {props.fullScreen}
    PaperProps={matches?{style:{margin:"0px",width:"calc(100% - 10px)",overflowY:"hidden",maxHeight:"calc(100% - 10px)"}}:{}}
    onClose={handleClose}>
        {children}
    </Dialog>
}

export default ConfirmDialog;